export default __webpack_public_path__ + "static/media/mail.42e0750e.svg";